import React from 'react'

import { StarSvg } from '@svg/react'

import { Unit } from '@adUtilities/types/apartment'

import { UNIT_CONFIGURATIONS } from './constants'

interface LevelUnitCardProps {
  unit: Unit
  statusColour: string
  isDisabled: boolean
  isShortlisted: boolean
  onSelect: () => void
  onToggleShortlist: () => void
}

function LevelUnitCard({
  unit,
  statusColour,
  isDisabled,
  isShortlisted,
  onSelect,
  onToggleShortlist,
}: LevelUnitCardProps) {
  const configurations = UNIT_CONFIGURATIONS.filter(
    ({ key }) => Number(unit.metas.configurations?.[key]) > 0
  )

  return (
    <div
      className={`relative rounded-md ${
        isDisabled ? 'pointer-events-none bg-[#C2C2C2]' : 'bg-white'
      }`}
    >
      <button
        type="button"
        disabled={isDisabled}
        onClick={onSelect}
        className="flex w-full flex-col gap-2 px-4 py-3 text-left xl:px-6 xl:py-4"
      >
        <span className="flex min-w-0 items-center pr-6">
          <span
            className="max-w-[65%] shrink-0 truncate font-bold"
            title={unit.name}
          >
            {unit.name}
          </span>
          <span
            className="ml-4 h-2 w-2 shrink-0 rounded-full"
            style={{ backgroundColor: statusColour }}
          />
          <span
            className="ml-1 truncate text-xs font-semibold uppercase tracking-widest"
            style={{ color: statusColour }}
          >
            {unit.metas.status}
          </span>
        </span>
        {configurations.length > 0 && (
          <span className="flex gap-3 text-zinc-500">
            {configurations.map(({ key, title, Icon }) => (
              <span
                key={key}
                className="inline-flex items-center gap-1 text-sm"
                title={title}
              >
                <Icon className="h-4 w-4" />
                {unit.metas.configurations[key]}
              </span>
            ))}
          </span>
        )}
      </button>
      <button
        type="button"
        title="Shortlist unit"
        aria-pressed={isShortlisted}
        onClick={onToggleShortlist}
        className="absolute right-0 top-0 flex h-12 items-center pl-2 pr-4 xl:h-14 xl:pr-6"
      >
        <StarSvg
          className={`h-4 w-4 ${
            isShortlisted
              ? 'stroke-amber-500 text-amber-500'
              : 'stroke-zinc-400 text-zinc-400'
          }`}
        />
      </button>
    </div>
  )
}

export default LevelUnitCard
